import { Event, Interface, Method } from '@central-products/transport-bus-common';
import { AccountActionsRequest, AccountActionsResponse, ActionsRequestedPayload } from './interfaces';

export type AccountActionsRequestedCallback = (payload: ActionsRequestedPayload) => void;

@Interface('common', 'account.action')
export class AccountActionsInterface {
  @Method('execute')
  // @ts-ignore
  public execute(data: AccountActionsRequest): Promise<AccountActionsResponse> {
    throw new Error('Method is not implemented yet');
  }

  @Event('requested')
  // @ts-ignore
  public onActionRequested(callback: AccountActionsRequestedCallback): () => void {
    throw new Error('Event is not implemented yet');
  }
}
